import LoadingPage from '@/components/common/LoadingPage';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';

import { useUsers } from '@/data/user';

import UserList from './components/list/UserList';
import Search from './Search';
import Filters from './Filters';

const UserListPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Users
        </CardTitle>
        <CardDescription>List of all ProFound Users.</CardDescription>
      </CardHeader>
      <CardContent>
        <Search />
        <Filters />
        <UserList />
      </CardContent>
    </Card>
  );
};

const ListPageLoader = () => {
  const users = useUsers();

  if (users.isLoading && !users.data) {
    return <LoadingPage />;
  }

  return <UserListPage />;
};

export default ListPageLoader;
